import photo1 from '@/assets/images/about-photo1.webp'
import photo2 from '@/assets/images/about-photo2.webp'
import photo3 from '@/assets/images/about-photo3.webp'

import styles from './About.module.scss'

function About() {
  return (
    <section className={styles.about} id="about">
      <div className={styles.top}>
        <p className={styles.counter}>01/</p>

        <div className={styles.titleWrap}>
          <h2 className={styles.title}>Триатлон</h2>

          <p className={styles.desc}>
            Вид спорта, представляющий собой мультиспортивную гонку, которая включает три дисциплины: плавание,
            велосипед и бег.
          </p>
        </div>
      </div>

      <div className={styles.main}>
        <div className={styles.types}>
          <span>Swim. </span>
          <span>Bike. </span>
          <span>Run.</span>
        </div>

        <ul className={styles.photos}>
          <li className={styles.photoItem}>
            <img className={`${styles.photo} lazyload`} src={photo1} width={216} height={220} alt="" />
          </li>
          <li className={styles.photoItem}>
            <img className={`${styles.photo} lazyload`} src={photo2} width={216} height={220} alt="" />
          </li>
          <li className={styles.photoItem}>
            <img className={`${styles.photo} lazyload`} src={photo3} width={216} height={220} alt="" />
          </li>
        </ul>

        <p className={styles.text}>
          Принимать участие в наших стартах могут абсолютно все желающие, независимо от возраста, опыта и физической
          подготовки.
        </p>
      </div>
    </section>
  )
}

export default About
